import { Component, EventEmitter, Input, OnInit, Output, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActiveScreensService } from '../../shared/_services/active-screens.service';
import { NavigationModel } from '../navigation.model';
import { HomeScreenObject} from './home-screen.object';
import { NavigationItem } from '@appkit4/angular-components/navigation';
@Component({
    selector: 'gtw-tasks',
    templateUrl: './tasks.component.html',
    styleUrls: ['./tasks.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TasksComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  
  @Input('app_navigation')
  set _app_navigation(value: any[]) {
    this.appNavigation = Array.isArray(value) ? value : [];
    this.rebuildNavList();
  }
  appNavigation: any[] = [];
  
  @Output() clickDomain = new EventEmitter<{tasks:NavigationModel, domainName:string}>();
  @Output('load-screens') loadScreen= new EventEmitter<any>();
  // @ViewChild('ullist') ulList?: ElementRef ;

  selectedDomainName: string = 'Home';
  selectedIndex: number = 0;
  selectedSubIndex: number = -1;
  solid: boolean = false;
  simple: boolean = true;
  collapsed: boolean = false;
  navList: Array<NavigationItem> = [];

  private navDomainMap: NavigationModel[] = [];
  selectionDetails:{tasks:NavigationModel, domainName:string} = {
    tasks: {id:"", label:"",parentTaskKey:"",children:[]},
    domainName: 'Home'
  }

  // height = 0;

  HOME_SCREEN_OBJECT =HomeScreenObject;

  // constructor(private navigationService:NavigationService,private el:ElementRef,
  //             private activeScreensService:ActiveScreensService) {
  //   this.height = this.el.nativeElement.offsetHeight;
  // }

  constructor(private activeScreensService:ActiveScreensService) {
  }

  ngOnInit(): void {
    this.selectedDomainName = 'Home';
    // this.rebuildNavList();
    this.setDomainNameFromHomePage();
  }

  setDomainNameFromHomePage(){//replace it with redux
    this.activeScreensService.domainName$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((name:string)=> {
      this.selectedDomainName=name;
      this.selectedIndex = this.getSelectedIndexFromDomain(name);
    });
  }

  onClickDomain(domain: NavigationModel, domainName: string) {
    this.selectedDomainName = domainName;
    this.selectionDetails.tasks = domain;
    this.selectionDetails.domainName = domainName;
    this.clickDomain.emit(this.selectionDetails);
    
  }

  loadHistoryScreen(screen:any){
    this.loadScreen.emit(screen);
  }

  onClickHomeDomain() {
    this.selectedDomainName = 'Home';
    this.selectedIndex = 0;
    this.loadScreen.emit(this.HOME_SCREEN_OBJECT);
    this.activeScreensService.setScreens(this.HOME_SCREEN_OBJECT);
    
  }

  onCollapsedSidebar(event: any): void {
    this.collapsed = !!event?.collapsed;
  }

  redirect(event: any): void {
    if (!event) {
      return;
    }
    const index = event?.selectedIndex ?? event?.index ?? this.selectedIndex;
    if (index === 0) {
      this.onClickHomeDomain();
      return;
    }

    const domain = this.navDomainMap[index - 1];
    if (domain) {
      this.onClickDomain(domain, domain.label);
    }
  }

  private rebuildNavList(): void {
    this.navDomainMap = (this.appNavigation || []).filter((domain: any) => domain?.label !== 'Home');
    this.navList = [
      { name: 'Home', prefixIcon: 'home' },
      ...this.navDomainMap.map((domain: any) => ({
        name: domain?.label || '',
        // Known top-level tax domains use a deterministic, legacy-aligned icon
        // so each domain stays visually distinct regardless of the legacy
        // font-awesome icon_css the backend hands us. Unknown domains keep the
        // backend-provided icon (normalized) as before.
        prefixIcon: this.getDomainIcon(domain?.label) ?? this.normalizeIcon(domain?.icon_css, domain?.label)
      }))
    ];
    this.selectedIndex = this.getSelectedIndexFromDomain(this.selectedDomainName);
  }

  private getSelectedIndexFromDomain(domainName: string): number {
    if (!domainName || domainName === 'Home') {
      return 0;
    }
    const domainIndex = this.navDomainMap.findIndex((domain: any) => domain?.label === domainName);
    return domainIndex >= 0 ? domainIndex + 1 : 0;
  }

  // Tokens we know are shipped by AppKit4 in node_modules/@appkit4/styles/images/icons/outline.
  // The AppKit4 nav template hard-appends `-outline`, so an unknown token
  // would silently render an empty <span> with no glyph. Keeping the list
  // in sync with `getFallbackIconByLabel` keeps the sidebar visually
  // complete even if the API hands us a legacy icon class name.
  private static readonly KNOWN_APPKIT_ICONS = new Set<string>([
    'home', 'dashboard', 'file', 'document-file', 'document-text',
    'document-policies', 'desktop', 'news', 'globe', 'globe-map', 'partnership',
    'calculator', 'pie-chart', 'target', 'gantt-chart', 'bar-chart',
    'umbrella', 'shield', 'email', 'login', 'person', 'upload', 'setting',
    'map-location', 'ticket'
  ]);

  private normalizeIcon(iconCss: string | undefined, label?: string): string {
    const fallback = this.getFallbackIconByLabel(label);
    if (!iconCss || typeof iconCss !== 'string') {
      return fallback;
    }

    const raw = iconCss.toLowerCase().trim();
    if (!raw) {
      return fallback;
    }

    // Handles values like:
    // "icon-globe-outline", "Appkit4-icon icon-globe-outline", "icon-globe-outline something"
    const iconMatch = raw.match(/icon-[a-z0-9-]+/);
    let token = iconMatch ? iconMatch[0] : raw;

    // Remove common legacy class/value noise.
    if (token.startsWith('fa') || token.includes('font-awesome')) {
      return fallback;
    }

    token = token.replace(/^icon-/, '');
    // ap-navigation template appends "-outline" automatically.
    // Keep only the base token here to avoid classes like "...-outline-outline".
    token = token.replace(/-(outline|fill)$/g, '');

    // AppKit nav expects kebab-case icon names without the "icon-" prefix.
    if (!/^[a-z0-9-]+$/.test(token)) {
      return fallback;
    }

    if (!token) {
      return fallback;
    }

    // Map legacy AngularJS icon names that no longer exist in AppKit4.
    const legacyAlias: { [key: string]: string } = {
      'people': 'partnership',
      'employees': 'partnership',
      'group': 'partnership',
      'building': 'partnership',
      'company': 'partnership',
      'industry': 'partnership',
      'document': 'document-file',
      'doc': 'document-file',
      'mail': 'email',
      'envelope': 'email',
      'gear': 'setting',
      'gears': 'setting',
      'cog': 'setting',
      'chart': 'bar-chart',
      'chart-bar': 'bar-chart',
      'chart-pie': 'pie-chart'
    };

    if (legacyAlias[token]) {
      token = legacyAlias[token];
    }

    if (!TasksComponent.KNOWN_APPKIT_ICONS.has(token)) {
      return fallback;
    }

    return token;
  }

  // Deterministic icon for known top-level tax domains. Returns undefined for
  // anything we don't explicitly recognize so the caller can fall back to the
  // backend-provided icon. Each domain gets a distinct glyph (e.g. Foreign vs
  // CbCr) and FTC/FDII uses a document/sheet icon rather than a calculator.
  private getDomainIcon(label?: string): string | undefined {
    const key = (label || '').toLowerCase().trim();
    if (!key) return undefined;
    if (key.includes('home')) return 'home';
    if (key.includes('review')) return 'bar-chart';
    if (key.includes('domestic')) return 'news';
    if (key.includes('foreign')) return 'globe-map';
    if (key.includes('partnership')) return 'partnership';
    if (key.includes('ftc') || key.includes('fdii')) return 'document-text';
    if (key.includes('insurance')) return 'desktop';
    if (key.includes('cbcr') || key.includes('cbc')) return 'globe';
    if (key.includes('efile') || key.includes('e-file')) return 'login';
    if (key.includes('admin')) return 'person';
    if (key.includes('ghost')) return 'shield';
    if (key.includes('gtaps')) return 'pie-chart';
    if (key.includes('state')) return 'map-location';
    return undefined;
  }

  private getFallbackIconByLabel(label?: string): string {
    return this.getDomainIcon(label) ?? 'ticket';
  }
}
